__turbopack_context__.v({
  "brand": "icon-module__Quza8G__brand",
  "icon": "icon-module__Quza8G__icon",
  "ideeri-dark": "icon-module__Quza8G__ideeri-dark",
  "ideeri-light": "icon-module__Quza8G__ideeri-light",
  "ideeri-primary": "icon-module__Quza8G__ideeri-primary",
  "ideeri-secondary": "icon-module__Quza8G__ideeri-secondary",
});
